import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { HrUpdateTermPayload } from 'api/actions/hr-update-term/hr-update-term-payload';
import { HrUpdateTermPathParameters } from 'api/actions/hr-update-term/hr-update-term-path-parameters';
import { HrUpdateTermResponse } from 'api/actions/hr-update-term/hr-update-term-response';

type HrUpdateTermQueryParameters = Record<string, any>;

/**
 * The path of the HrUpdateTerm action.
 */
export const hrUpdateTermActionPath = new SweetPath<keyof HrUpdateTermPathParameters>('/api/hr/terms/{termId}', {
  path: '{param}',
});

/**
 * Creates a contextualized HrUpdateTerm actions.
 */
export default function createHrUpdateTermAction(axios: AxiosInstance) {
  return function hrUpdateTermAction({
    headers = {},
    parameters,
    query = {},
    payload,
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: HrUpdateTermPathParameters;
    query?: HrUpdateTermQueryParameters;
    payload: HrUpdateTermPayload;
  }) {
    const path = hrUpdateTermActionPath.insert(parameters);

    return axios.request<HrUpdateTermResponse, HrUpdateTermResponse>({
      method: 'put',
      url: path,
      params: query,
      data: payload,
      headers,
    });
  };
}
